webpackJsonp([152176518627018],{

/***/ 224:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(4);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _gatsbyImage = __webpack_require__(9);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _Divider = __webpack_require__(6);
	
	var _Divider2 = _interopRequireDefault(_Divider);
	
	var _Fill = __webpack_require__(5);
	
	var _Fill2 = _interopRequireDefault(_Fill);
	
	var _Calendar = __webpack_require__(65);
	
	var _Calendar2 = _interopRequireDefault(_Calendar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var query = exports.query = '** extracted graphql fragment **';
	
	var Blog = function Blog(_ref) {
	  var _ref$data = _ref.data,
	      bone = _ref$data.bone,
	      btwo = _ref$data.btwo,
	      bthree = _ref$data.bthree;
	  return _react2.default.createElement(
	    'section',
	    null,
	    _react2.default.createElement(
	      'article',
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'container' },
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { style: { display: 'block' } },
	            _react2.default.createElement(
	              'h1',
	              { className: 'smallerHone' },
	              'Blog'
	            ),
	            _react2.default.createElement('img', { src: _Divider2.default, alt: 'Nisadhya - Divider', style: { margin: '.75rem 0' } }),
	            _react2.default.createElement(
	              'p',
	              { className: 'smallerHone' },
	              _react2.default.createElement(
	                'span',
	                { className: 'gradient' },
	                'Case studies such as these inspire and motivate us.'
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              { style: { marginBottom: '0' } },
	              'See how businesses similar to yours are growing with Digital Marketing.'
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'container', style: { paddingTop: '0' } },
	        _react2.default.createElement(
	          'div',
	          { className: 'full-Width', style: { alignItems: 'flex-start', justifyContent: 'space-between' } },
	          _react2.default.createElement(
	            'div',
	            { className: 'half-Width-30 mobBottommargin' },
	            _react2.default.createElement(
	              'div',
	              { className: 'case-studies' },
	              _react2.default.createElement(
	                'div',
	                { style: { overflow: 'hidden' } },
	                _react2.default.createElement(
	                  _gatsbyLink2.default,
	                  { to: '/blog/digital-marketing-why-and-how-it-is-your-smartest-move/' },
	                  _react2.default.createElement(_gatsbyImage2.default, { className: 'case-studies-img', sizes: bthree.bthreechild.sizes, alt: '' })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { style: { padding: '1.0875rem', display: 'block' } },
	                _react2.default.createElement(
	                  'h1',
	                  { className: 'smallerHone' },
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'gradient' },
	                    'Digital Marketing: Why and how it is your Smartest Move.'
	                  )
	                ),
	                _react2.default.createElement(
	                  'p',
	                  { style: { display: 'flex', alignItems: 'center', margin: '0.75rem 0 0 0', fontSize: '.9rem' } },
	                  _react2.default.createElement('img', { src: _Calendar2.default, alt: 'Nisadhya - Calendar', style: { width: '1.25rem', marginRight: '.5rem' } }),
	                  '14',
	                  _react2.default.createElement(
	                    'sup',
	                    null,
	                    'th'
	                  ),
	                  ' March 2019'
	                ),
	                _react2.default.createElement('img', { src: _Fill2.default, style: { margin: '.75rem 0' }, alt: 'Nisadhya - Divider' }),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'Digital marketing as the term suggests is marketing digitally especially through the internet because it\'s 2019 and everyone is stuck with their mobile devices or any other digital medium. '
	                ),
	                _react2.default.createElement(
	                  _gatsbyLink2.default,
	                  { to: '/blog/digital-marketing-why-and-how-it-is-your-smartest-move/', className: 'slide gradient' },
	                  'Read More'
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'half-Width-30 mobBottommargin' },
	            _react2.default.createElement(
	              'div',
	              { className: 'case-studies' },
	              _react2.default.createElement(
	                'div',
	                { style: { overflow: 'hidden' } },
	                _react2.default.createElement(
	                  _gatsbyLink2.default,
	                  { to: '/blog/why-is-content-marketing-important/' },
	                  _react2.default.createElement(_gatsbyImage2.default, { className: 'case-studies-img', sizes: btwo.btwochild.sizes, alt: '' })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { style: { padding: '1.0875rem' } },
	                _react2.default.createElement(
	                  'h1',
	                  { className: 'smallerHone' },
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'gradient' },
	                    'Why is Content Marketing important?'
	                  )
	                ),
	                _react2.default.createElement(
	                  'p',
	                  { style: { display: 'flex', alignItems: 'center', margin: '0.75rem 0 0 0', fontSize: '.9rem' } },
	                  _react2.default.createElement('img', { src: _Calendar2.default, alt: 'Nisadhya - Calendar', style: { width: '1.25rem', marginRight: '.5rem' } }),
	                  '8',
	                  _react2.default.createElement(
	                    'sup',
	                    null,
	                    'th'
	                  ),
	                  ' March 2019'
	                ),
	                _react2.default.createElement('img', { src: _Fill2.default, style: { margin: '.75rem 0' }, alt: 'Nisadhya - Divider' }),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'Content marketing is not only about advertising, it is about generating awareness about who you are, what you do and what you can offer. So, that people trust you and your business.'
	                ),
	                _react2.default.createElement(
	                  _gatsbyLink2.default,
	                  { to: '/blog/why-is-content-marketing-important/', className: 'slide gradient' },
	                  'Read More'
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'half-Width-30' },
	            _react2.default.createElement(
	              'div',
	              { className: 'case-studies' },
	              _react2.default.createElement(
	                'div',
	                { style: { overflow: 'hidden' } },
	                _react2.default.createElement(
	                  _gatsbyLink2.default,
	                  { to: '/blog/why-is-it-important-to-market-your-business-digitally/' },
	                  _react2.default.createElement(_gatsbyImage2.default, { className: 'case-studies-img', sizes: bone.bonechild.sizes, alt: '' })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { style: { padding: '1.0875rem' } },
	                _react2.default.createElement(
	                  'h1',
	                  { className: 'smallerHone' },
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'gradient' },
	                    'Why is it important to market your business digitally?'
	                  )
	                ),
	                _react2.default.createElement(
	                  'p',
	                  { style: { display: 'flex', alignItems: 'center', margin: '0.75rem 0 0 0', fontSize: '.9rem' } },
	                  _react2.default.createElement('img', { src: _Calendar2.default, alt: 'Nisadhya - Calendar', style: { width: '1.25rem', marginRight: '.5rem' } }),
	                  '1',
	                  _react2.default.createElement(
	                    'sup',
	                    null,
	                    'st'
	                  ),
	                  ' March 2019'
	                ),
	                _react2.default.createElement('img', { src: _Fill2.default, style: { margin: '.75rem 0' }, alt: 'Nisadhya - Divider' }),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'People are more inclined to information over the Internet than other media sources. The Internet has transformed the way we interact, and how we share information, including how we market our businesses.'
	                ),
	                _react2.default.createElement(
	                  _gatsbyLink2.default,
	                  { to: '/blog/why-is-it-important-to-market-your-business-digitally/', className: 'slide gradient' },
	                  'Read More'
	                )
	              )
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = Blog;

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-blog-index-js-ccb3b5e43d2706b54697.js